import React, { createContext, useContext } from 'react';
import useSyncValidation from '../hooks/useSyncValidation';

const SyncValidationContext = createContext();

export const useSyncValidationContext = () => {
  const context = useContext(SyncValidationContext);
  if (!context) {
    throw new Error('useSyncValidationContext must be used within a SyncValidationProvider');
  }
  return context;
};

export const SyncValidationProvider = ({ children }) => {
  const syncValidation = useSyncValidation();

  return (
    <SyncValidationContext.Provider value={syncValidation}>
      {children}
    </SyncValidationContext.Provider>
  );
}; 